import React from 'react';
import HistoryPage from 'src/components/common/history/HistoryPage';
import { useMassActionState } from 'src/components/massAction/MassActionStateContext';
import { useParams } from 'wouter';

const MassActionHistory = () => {
  const params = useParams();
  const [{ massActions, criteriaByKey }] = useMassActionState();
  const campaignId = Number(params.id);
  const campaignToEdit = massActions.find(massAction => massAction.id === campaignId);

  return (
    <HistoryPage
      filtersByKey={criteriaByKey}
      campaign={campaignToEdit}
      excludedProperties={['targetWithOptin', 'targetTotal', 'isTest', 'prospectingTypeName']}
      summaryExcludedProperties={['launchedBy', 'status']}
      rowSpanCols={['clubName', 'date', 'targetNumber', 'optinType']}
      sortable={['clubName', 'date', 'targetNumber', 'optinType']}
      receiveHistory={history =>
        Object.entries(history.globalStatsList).reduce(
          (m, [k, e]) => [
            ...m,
            {
              id: k,
              items: e.map(i => ({
                ...i,
                setupValue: JSON.parse(i.setupValue),
                setupColumns: JSON.parse(i.setupColumns),
              })),
            },
          ],
          []
        )
      }
    />
  );
};

export default MassActionHistory;
